// src/utils/staticTranslations.js
/**
 * Static translations for common UI elements
 */

// Form labels
export const formLabels = {
  en: {
    name: "Full Name",
    email: "Email ID",
    phone: "Phone No.",
    password: "Password",
    submit: "Submit",
    cancel: "Cancel",
    next: "Next",
    back: "Back",
    login: "Login",
    logout: "Logout",
    comment: "Comment",
    date: "Date",
    time: "Time",
    additionalComments: "Additional Comments (Optional)",
    service: "Select Service",
    consultation: "Consultation",
    personalDetails: "Personal Details",
    selectDate: "Select Date",
    selectTime: "Select Time Slot"
  },
  hi: {
    name: "पूरा नाम",
    email: "ईमेल आईडी",
    phone: "फोन नंबर",
    password: "पासवर्ड",
    submit: "सबमिट करें",
    cancel: "रद्द करें",
    next: "अगला",
    back: "पीछे",
    login: "लॉगिन",
    logout: "लॉगआउट",
    comment: "टिप्पणी",
    date: "दिनांक",
    time: "समय",
    additionalComments: "अतिरिक्त टिप्पणियाँ (वैकल्पिक)",
    service: "सेवा चुनें",
    consultation: "परामर्श",
    personalDetails: "व्यक्तिगत विवरण",
    selectDate: "दिनांक चुनें",
    selectTime: "समय स्लॉट चुनें"
  },
  gu: {
    name: "પૂરું નામ",
    email: "ઈમેઇલ આઈડી",
    phone: "ફોન નંબર",
    password: "પાસવર્ડ",
    submit: "સબમિટ કરો",
    cancel: "રદ કરો",
    next: "આગળ",
    back: "પાછળ",
    login: "લોગિન",
    logout: "લોગઆઉટ",
    comment: "ટિપ્પણી",
    date: "તારીખ",
    time: "સમય",
    additionalComments: "વધારાની ટિપ્પણીઓ (વૈકલ્પિક)",
    service: "સેવા પસંદ કરો",
    consultation: "પરામર્શ",
    personalDetails: "વ્યક્તિગત વિગતો",
    selectDate: "તારીખ પસંદ કરો",
    selectTime: "સમય સ્લોટ પસંદ કરો"
  },
  kn: {
    name: "ಪೂರ್ಣ ಹೆಸರು",
    email: "ಇಮೇಲ್ ಐಡಿ",
    phone: "ಫೋನ್ ನಂಬರ್",
    password: "ಪಾಸ್ವರ್ಡ್",
    submit: "ಸಲ್ಲಿಸು",
    cancel: "ರದ್ದುಮಾಡು",
    next: "ಮುಂದೆ",
    back: "ಹಿಂದೆ",
    login: "ಲಾಗಿನ್",
    logout: "ಲಾಗ್ಔಟ್",
    comment: "ಕಾಮೆಂಟ್",
    date: "ದಿನಾಂಕ",
    time: "ಸಮಯ",
    additionalComments: "ಹೆಚ್ಚುವರಿ ಕಾಮೆಂಟ್‌ಗಳು (ಐಚ್ಛಿಕ)",
    service: "ಸೇವೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    consultation: "ಸಮಾಲೋಚನೆ",
    personalDetails: "ವೈಯಕ್ತಿಕ ವಿವರಗಳು",
    selectDate: "ದಿನಾಂಕವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    selectTime: "ಸಮಯ ಸ್ಲಾಟ್ ಆಯ್ಕೆಮಾಡಿ"
  }
};

// Button labels
export const buttonLabels = {
  en: {
    talk: "Talk",
    chat: "Chat",
    clearHistory: "Clear Chat History",
    startNew: "Start New Conversation",
    contact: "Contact Us",
    feedback: "Feedback",
    appointment: "Book Appointment",
    status: "Status",
    tasks: "Tasks",
    update: "Update",
    delete: "Delete",
    download: "Download",
    help: "Help",
    startNewConversation: "Start New Conversation",
    searchParticipants: "Search Participants...",
    typeMessage: "Type a message...",
    startConversation: "Click to start Conversation",
    closeConversation: "Click to close Conversation"
  },
  hi: {
    talk: "बात करें",
    chat: "चैट",
    clearHistory: "चैट इतिहास साफ़ करें",
    startNew: "नई बातचीत शुरू करें",
    contact: "संपर्क करें",
    feedback: "प्रतिक्रिया",
    appointment: "अपॉइंटमेंट बुक करें",
    status: "स्टेटस",
    tasks: "कार्य",
    update: "अपडेट",
    delete: "हटाएं",
    download: "डाउनलोड",
    help: "मदद",
    startNewConversation: "नई बातचीत शुरू करें",
    searchParticipants: "प्रतिभागी खोजें...",
    typeMessage: "एक संदेश टाइप करें...",
    startConversation: "बातचीत शुरू करें",
    closeConversation: "बातचीत बंद करें"
  },
  gu: {
    talk: "વાત કરો",
    chat: "ચેટ",
    clearHistory: "ચેટ ઇતિહાસ સાફ કરો",
    startNew: "નવી વાતચીત શરૂ કરો",
    contact: "સંપર્ક કરો",
    feedback: "પ્રતિસાદ",
    appointment: "અપોઇન્ટમેન્ટ બુક કરો",
    status: "સ્થિતિ",
    tasks: "કાર્યો",
    update: "અપડેટ",
    delete: "કાઢી નાખો",
    download: "ડાઉનલોડ",
    help: "મદદ",
    startNewConversation: "નવી વાતચીત શરૂ કરો",
    searchParticipants: "પ્રતિભાગી શોધો...",
    typeMessage: "એક સંદેશ ટાઇપ કરો...",
    startConversation: "વાતચીત શરૂ કરો",
    closeConversation: "વાતચીત બંધ કરો"
  },
  kn: {
    talk: "ಮಾತನಾಡಿ",
    chat: "ಚಾಟ್",
    clearHistory: "ಚಾಟ್ ಇತಿಹಾಸವನ್ನು ತೆರವುಗೊಳಿಸಿ",
    startNew: "ಹೊಸ ಸಂಭಾಷಣೆಯನ್ನು ಪ್ರಾರಂಭಿಸಿ",
    contact: "ಸಂಪರ್ಕಿಸಿ",
    feedback: "ಪ್ರತಿಕ್ರಿಯೆ",
    appointment: "ಅಪಾಯಿಂಟ್ಮೆಂಟ್ ಬುಕ್ ಮಾಡಿ",
    status: "ಸ್ಥಿತಿ",
    tasks: "ಕಾರ್ಯಗಳು",
    update: "ಅಪ್ಡೇಟ್",
    delete: "ಅಳಿಸಿ",
    download: "ಡೌನ್‌ಲೋಡ್",
    help: "ಸಹಾಯ",
    startNewConversation: "ಹೊಸ ಸಂಭಾಷಣೆಯನ್ನು ಪ್ರಾರಂಭಿಸಿ",
    searchParticipants: "ಸಹಭಾಗಿಗಳನ್ನು ಹುಡುಕಿ...",
    typeMessage: "ಒಂದು ಸಂದೇಶವನ್ನು ಟೈಪ್ ಮಾಡಿ...",
    startConversation: "ಸಂಭಾಷಣೆ ಶುರುವಾಗಿಸಿ",
    closeConversation: "ಸಂಭಾಷಣೆ ಮುರುಗುವಾಗಿಸಿ"
  }
};

// Common messages
export const commonMessages = {
  en: {
    welcome: "Welcome",
    howCanIHelp: "How can I help you today?",
    greeting: "Hello! How can I assist you?",
    noMessages: "No messages in this conversation",
    loading: "Loading...",
    error: "An error occurred. Please try again.",
    sessionExpired: "Your session has expired. Please log in again.",
    loggedOut: "You have been logged out successfully.",
    noResults: "No results found.",
    selectParticipant: "Select a participant",
    conversationWith: "Conversation with",
    poweredBy: "Powered by",
    chatHistory: "Chat History",
    customerSupport: "Customer Support",
    reminders: "Reminders",
    reminder: "Reminder",
    participants: "Participants",
    conversation: "Conversation"
  },
  hi: {
    welcome: "स्वागत है",
    howCanIHelp: "आज मैं आपकी कैसे सहायता कर सकता हूँ?",
    greeting: "नमस्ते! मैं आपकी कैसे सहायता कर सकता हूँ?",
    noMessages: "इस वार्तालाप में कोई संदेश नहीं है",
    loading: "लोड हो रहा है...",
    error: "एक त्रुटि हुई। कृपया पुनः प्रयास करें।",
    sessionExpired: "आपका सत्र समाप्त हो गया है। कृपया फिर से लॉगिन करें।",
    loggedOut: "आप सफलतापूर्वक लॉगआउट हो गए हैं।",
    noResults: "कोई परिणाम नहीं मिला।",
    selectParticipant: "एक प्रतिभागी का चयन करें",
    conversationWith: "के साथ वार्तालाप",
    poweredBy: "द्वारा संचालित",
    chatHistory: "चैट का इतिहास",
    customerSupport: "ग्राहक सहायता",
    reminders: "स्मरण",
    reminder: "स्मरण",
    participants: "प्रतिभागी",
    conversation: "वार्तालाप"
  },
  gu: {
    welcome: "સ્વાગત છે",
    howCanIHelp: "આજે હું તમને કેવી રીતે મદદ કરી શકું?",
    greeting: "નમસ્તે! હું તમને કેવી રીતે મદદ કરી શકું?",
    noMessages: "આ વાતચીતમાં કોઈ સંદેશા નથી",
    loading: "લોડ થઈ રહ્યું છે...",
    error: "એક ભૂલ આવી. કૃપા કરીને ફરી પ્રયત્ન કરો.",
    sessionExpired: "તમારું સત્ર સમાપ્ત થઈ ગયું છે. કૃપા કરીને ફરીથી લૉગિન કરો.",
    loggedOut: "તમે સફળતાપૂર્વક લૉગઆઉટ થયા છો.",
    noResults: "કોઈ પરિણામ મળ્યું નથી.",
    selectParticipant: "એક સહભાગી પસંદ કરો",
    conversationWith: "સાથે વાતચીત",
    poweredBy: "દ્વારા સંચાલિત",
    chatHistory: "ચેટ ઇતિહાસ",
    customerSupport: "ગ્રાહક આધાર",
    reminders: "રીમાઇન્ડર્સ",
    reminder: "રીમાઇન્ડર",
    participants: "સહભાગીઓ",
    conversation: "વાતચીત"
  },
  kn: {
    welcome: "ಸ್ವಾಗತ",
    howCanIHelp: "ಇಂದು ನಾನು ನಿಮಗೆ ಹೇಗೆ ಸಹಾಯ ಮಾಡಬಹುದು?",
    greeting: "ನಮಸ್ಕಾರ! ನಾನು ನಿಮಗೆ ಹೇಗೆ ಸಹಾಯ ಮಾಡಬಹುದು?",
    noMessages: "ಈ ಸಂಭಾಷಣೆಯಲ್ಲಿ ಯಾವುದೇ ಸಂದೇಶಗಳಿಲ್ಲ",
    loading: "ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
    error: "ದೋಷ ಸಂಭವಿಸಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    sessionExpired: "ನಿಮ್ಮ ಸೆಷನ್ ಅವಧಿ ಮುಗಿದಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಲಾಗಿನ್ ಮಾಡಿ.",
    loggedOut: "ನೀವು ಯಶಸ್ವಿಯಾಗಿ ಲಾಗ್ಔಟ್ ಆಗಿದ್ದೀರಿ.",
    noResults: "ಯಾವುದೇ ಫಲಿತಾಂಶಗಳು ಕಂಡುಬಂದಿಲ್ಲ.",
    selectParticipant: "ಭಾಗವಹಿಸುವವರನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    conversationWith: "ಜೊತೆಗಿನ ಸಂಭಾಷಣೆ",
    poweredBy: "ಮೂಲಕ ಪವರ್ಡ್",
    chatHistory: "ಚಾಟ್ ಇತಿಹಾಸ",
    customerSupport: "ಗ್ರಾಹಕ ಬೆಂಬಲ",
    reminders: "ಜ್ಞಾಪನೆಗಳು",
    reminder: "ಜ್ಞಾಪನೆ",
    participants: "ಭಾಗವಹಿಸುವವರು",
    conversation: "ಸಂಭಾಷಣೆ"
  }
};

// Error messages
export const errorMessages = {
  en: {
    required: "This field is required",
    invalidEmail: "Please enter a valid email address",
    invalidPhone: "Please enter a valid phone number",
    invalidName: "Please enter a valid name",
    invalidPassword: "Password must be at least 8 characters",
    loginFailed: "Login failed. Please check your credentials.",
    connectionError: "Connection error. Please try again.",
    sessionExpired: "Your session has expired. Please log in again."
  },
  hi: {
    required: "यह फ़ील्ड आवश्यक है",
    invalidEmail: "कृपया एक वैध ईमेल पता दर्ज करें",
    invalidPhone: "कृपया एक वैध फोन नंबर दर्ज करें",
    invalidName: "कृपया एक वैध नाम दर्ज करें",
    invalidPassword: "पासवर्ड कम से कम 8 अक्षर का होना चाहिए",
    loginFailed: "लॉगिन विफल। कृपया अपने क्रेडेंशियल्स की जाँच करें।",
    connectionError: "कनेक्शन त्रुटि। कृपया पुनः प्रयास करें।",
    sessionExpired: "आपका सत्र समाप्त हो गया है। कृपया फिर से लॉगिन करें।"
  },
  gu: {
    required: "આ ફીલ્ડ આવશ્યક છે",
    invalidEmail: "કૃપા કરીને માન્ય ઈમેલ સરનામું દાખલ કરો",
    invalidPhone: "કૃપા કરીને માન્ય ફોન નંબર દાખલ કરો",
    invalidName: "કૃપા કરીને માન્ય નામ દાખલ કરો",
    invalidPassword: "પાસવર્ડ ઓછામાં ઓછા 8 અક્ષરનો હોવો જોઈએ",
    loginFailed: "લૉગિન નિષ્ફળ. કૃપા કરીને તમારા ઓળખપત્રો તપાસો.",
    connectionError: "કનેક્શન ભૂલ. કૃપા કરીને ફરી પ્રયત્ન કરો.",
    sessionExpired: "તમારું સત્ર સમાપ્ત થઈ ગયું છે. કૃપા કરીને ફરીથી લૉગિન કરો."
  },
  kn: {
    required: "ಈ ಕ್ಷೇತ್ರವು ಅಗತ್ಯವಾಗಿದೆ",
    invalidEmail: "ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
    invalidPhone: "ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    invalidName: "ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
    invalidPassword: "ಪಾಸ್ವರ್ಡ್ ಕನಿಷ್ಠ 8 ಅಕ್ಷರಗಳನ್ನು ಹೊಂದಿರಬೇಕು",
    loginFailed: "ಲಾಗಿನ್ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ನಿಮ್ಮ ರುಜುವಾತುಗಳನ್ನು ಪರಿಶೀಲಿಸಿ.",
    connectionError: "ಸಂಪರ್ಕ ದೋಷ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    sessionExpired: "ನಿಮ್ಮ ಸೆಷನ್ ಅವಧಿ ಮುಗಿದಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಲಾಗಿನ್ ಮಾಡಿ."
  }
};

/**
 * Get a translated message from the static translations
 * @param {string} key - The key of the message
 * @param {string} category - The category ('formLabels', 'buttonLabels', etc.)
 * @param {string} languageCode - The language code (en, hi, gu, kn)
 * @returns {string} - The translated message or the key if not found
 */
export const getStaticTranslation = (key, category, languageCode = 'en') => {
  if (!key || !category) return '';
  
  // Get the category object
  const categoryObj = 
    category === 'formLabels' ? formLabels : 
    category === 'buttonLabels' ? buttonLabels :
    category === 'commonMessages' ? commonMessages :
    category === 'errorMessages' ? errorMessages : null;
  
  if (!categoryObj) return key;
  
  // Get the language object
  const languageObj = categoryObj[languageCode] || categoryObj.en;
  
  // Return the translation or the key if not found
  return languageObj[key] || key;
};

/**
 * Custom hook to use static translations
 * @param {string} languageCode - The language code
 * @returns {object} - Translation helper functions
 */
export const useStaticTranslations = (languageCode = 'en') => {
  return {
    t: (key, category) => getStaticTranslation(key, category, languageCode),
    formLabel: (key) => getStaticTranslation(key, 'formLabels', languageCode),
    buttonLabel: (key) => getStaticTranslation(key, 'buttonLabels', languageCode),
    commonMessage: (key) => getStaticTranslation(key, 'commonMessages', languageCode),
    errorMessage: (key) => getStaticTranslation(key, 'errorMessages', languageCode),
  };
};